import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SessionService } from './session.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private readonly statuses = [400, 401, 403, 500];
  // we skip 403 below
  // because it idicates lack of access to specific resource
  // other than missing authorization in general
  // this caused missing access to chat token
  private readonly authInvalidationStatuses = [401];

  constructor(
    private router: Router,
    private session: SessionService
  ) {}

  private readonly tokenEndpoints = ['/chat/users/', '/integrations/users/'];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpEvent<any>) => {
        if (error instanceof HttpErrorResponse && this.statuses.includes(error.status)) {
          const isTokenRequest = this.tokenEndpoints.some((e) => request.url.includes(e));
          if (this.authInvalidationStatuses.includes(error.status)) {
            this.session.invalidate();
          }
          if (!isTokenRequest) {
            this.router.navigate(['error'], { state: { codeStatus: error.status } });
          }
        }

        return throwError(error);
      })
    );
  }
}
